import { Link } from "react-router-dom";
import { films } from "@/mocks/films";
import { useFavorites } from "@/hooks/useFavorites";
import { useSEO } from "@/hooks/useSEO";
import Breadcrumb from "@/components/base/Breadcrumb";
import EmptyState from "@/components/base/EmptyState";
import FilmCard from "@/components/base/FilmCard";

export default function FavoritesPage() {
  const { favorites, clearFavorites } = useFavorites();

  useSEO({
    title: "我的收藏 - 星光传媒影视平台",
    description: "查看并管理你收藏的星光传媒影视作品，收藏记录保存在本地浏览器中。",
    keywords: "星光传媒,我的收藏,影视收藏",
  });

  const list = films.filter((film) => favorites.includes(film.id));

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-12">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "我的收藏" }]} />

      <header className="mt-4 flex flex-wrap items-end justify-between gap-4 border-b border-background-200 pb-6">
        <div>
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            我的收藏
          </h1>
          <p className="mt-3 text-sm text-foreground-600">
            共收藏 <strong className="text-foreground-900">{list.length}</strong> 部作品，收藏内容保存在本地浏览器中。
          </p>
        </div>
        {list.length > 0 && (
          <button
            type="button"
            onClick={clearFavorites}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            <i className="ri-delete-bin-line" />
            清空收藏
          </button>
        )}
      </header>

      <div className="mt-8">
        {list.length === 0 ? (
          <EmptyState
            icon="ri-heart-line"
            title="收藏夹还是空的"
            desc="浏览影视作品时点击右下角的心形按钮，就能把喜欢的作品收藏到这里。"
            action={
              <div className="flex flex-wrap justify-center gap-3">
                <Link
                  to="/category/movie"
                  className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  去看电影
                </Link>
                <Link
                  to="/category/tv"
                  className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
                >
                  去看电视剧
                </Link>
              </div>
            }
          />
        ) : (
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 md:gap-5">
            {list.map((film) => (
              <FilmCard key={film.id} film={film} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}